<template>
  <v-container fluid class="perfil-page py-4 px-8">
    <v-row dense>
      <v-col cols="12">
        <v-card class="perfil-hero" elevation="1">
          <v-card-text>
            <div class="perfil-hero-content">
              <v-avatar size="76" color="white" class="perfil-avatar">
                <v-icon size="42" color="light-blue darken-2">mdi-account-circle</v-icon>
              </v-avatar>
              <div class="perfil-title-block">
                <div class="text-h5 font-weight-bold perfil-title">{{ nombreCompletoUsuario }}</div>
                <div class="text-body-2 perfil-subtitle">
                  CI {{ usuario.num_doc || 'S/D' }} · {{ totalCargos }} cargos registrados
                </div>
                <div class="mt-2">
                  <v-chip small color="light-blue lighten-5" text-color="light-blue darken-4">
                    <v-icon left small>mdi-briefcase-account</v-icon>
                    {{ cargoActualTexto }}
                  </v-chip>
                </div>
              </div>
              <v-spacer></v-spacer>
              <img v-if="img_logo" :src="img_logo" class="perfil-logo" alt="Logo">
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" lg="8">
        <v-card outlined class="perfil-card">
          <v-card-title class="perfil-card-title">
            <div>
              <div class="text-subtitle-1 font-weight-bold">Informacion de Recursos Humanos</div>
              <div class="text-caption grey--text text--darken-1">Datos laborales vinculados al documento del usuario</div>
            </div>
            <v-spacer></v-spacer>
            <v-chip v-if="buscandoTalento" small color="blue-grey lighten-5" text-color="blue-grey darken-2">
              Consultando...
            </v-chip>
            <v-chip v-else-if="existeInTalento" small :color="talento.vigente ? 'green lighten-4' : 'red lighten-4'" :text-color="talento.vigente ? 'green darken-4' : 'red darken-4'">
              {{ talento.vigente ? 'Vigente' : 'No vigente' }}
            </v-chip>
            <v-chip v-else small color="grey lighten-3" text-color="grey darken-3">Sin registro</v-chip>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-skeleton-loader v-if="buscandoTalento" type="article" />

            <v-alert v-else-if="talentoError" type="warning" dense outlined class="mb-0">
              {{ talentoError }}
            </v-alert>

            <div v-else-if="datosTalento">
              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="perfil-field">
                    <span>Nombre completo</span>
                    <strong>{{ nombreCompletoTalento }}</strong>
                  </div>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="perfil-field">
                    <span>CI</span>
                    <strong>{{ ciTalento }}</strong>
                  </div>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="perfil-field">
                    <span>Fecha nacimiento</span>
                    <strong>{{ fechaCorta(datosTalento.fechaNacimiento) }}</strong>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="perfil-field">
                    <span>Correo</span>
                    <strong>{{ datosTalento.correoElectronico || 'S/D' }}</strong>
                  </div>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="perfil-field">
                    <span>Celular</span>
                    <strong>{{ datosTalento.celular || 'S/D' }}</strong>
                  </div>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="perfil-field">
                    <span>Profesion</span>
                    <strong>{{ datosTalento.profesionOcupacion || 'S/D' }}</strong>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="perfil-field">
                    <span>Grado academico</span>
                    <strong>{{ datosTalento.gradoAcademico || 'S/D' }}</strong>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="perfil-field">
                    <span>Nacimiento</span>
                    <strong>{{ lugarNacimientoTalento }}</strong>
                  </div>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <div class="perfil-contract">
                <div class="perfil-contract-icon">
                  <v-icon color="deep-orange darken-3">mdi-file-document-check</v-icon>
                </div>
                <div>
                  <div class="text-subtitle-2 font-weight-bold">{{ ultimoContrato.cargo || 'Cargo no registrado' }}</div>
                  <div class="text-body-2 grey--text text--darken-2">
                    {{ ultimoContrato.tipoContrato || 'Contrato S/D' }} · {{ ultimoContrato.area || 'Area S/D' }}
                  </div>
                  <div class="text-caption grey--text text--darken-1">
                    Inicio {{ fechaCorta(ultimoContrato.fechaInicio) }} · Fin {{ fechaCorta(ultimoContrato.fechaFin) || 'Vigente' }}
                  </div>
                </div>
              </div>
            </div>

            <v-alert v-else type="info" dense outlined class="mb-0">
              No se encontro informacion en Talento Humano para este CI.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" lg="4">
        <v-card outlined class="perfil-card">
          <v-card-title class="perfil-card-title">
            <div>
              <div class="text-subtitle-1 font-weight-bold">Seguridad</div>
              <div class="text-caption grey--text text--darken-1">Cambio de clave del portal</div>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <Datos />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card outlined class="perfil-card">
          <v-card-title class="perfil-card-title flex-wrap">
            <div>
              <div class="text-subtitle-1 font-weight-bold">Cargos de usuario</div>
              <div class="text-caption grey--text text--darken-1">Listado compacto de accesos asignados en el portal</div>
            </div>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="buscarCargo"
              dense
              outlined
              hide-details
              clearable
              prepend-inner-icon="mdi-magnify"
              label="Buscar cargo o sede"
              class="perfil-search"
            />
          </v-card-title>

          <v-data-table
            :headers="headersCargos"
            :items="cargosFiltrados"
            :items-per-page="12"
            dense
            class="perfil-table"
            no-data-text="No hay cargos para mostrar"
            :footer-props="{ 'items-per-page-options': [12, 24, 48, -1] }"
          >
            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>
            <template v-slot:[`item.sede_nombre`]="{ item }">
              <v-chip small color="blue-grey lighten-5" text-color="blue-grey darken-3">
                {{ nombreSedeCargo(item) }}
              </v-chip>
            </template>
            <template v-slot:[`item.cargo_nombre`]="{ item }">
              <span class="font-weight-medium">{{ nombreCargo(item) }}</span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <notifications group="auth" position="bottom right" />
  </v-container>
</template>

<script>
import Datos from '@/components/AClave.vue'
import {parseJsonError} from '@/components/Utils.js'
import gql from 'graphql-tag'

export default {
  components:{Datos},
  data(){
    return{
      img_logo: process.env.VUE_APP_LOGO,
      usuario:{
        cargos: [],
      },
      buscarCargo: '',
      talento: null,
      buscandoTalento: false,
      existeInTalento: false,
      talentoError: '',
      headersCargos: [
        { text: '#', value: 'index', width: 70, sortable: false },
        { text: 'Sede', value: 'sede_nombre', width: 260 },
        { text: 'Cargo', value: 'cargo_nombre' },
      ],
    }
  },
  computed:{
    nombreCompletoUsuario(){
      return this.parseUs();
    },
    totalCargos(){
      return Array.isArray(this.usuario.cargos) ? this.usuario.cargos.length : 0;
    },
    cargoActualTexto(){
      const cargo = this.$store.state.CARGO;
      if (!cargo) return 'Sin cargo activo';
      const sede = cargo.sede && cargo.sede.nombre ? cargo.sede.nombre : 'Sede S/D';
      const nombre = cargo.cargo && cargo.cargo.nombre ? cargo.cargo.nombre : cargo.nombre || 'Cargo S/D';
      return `${nombre} · ${sede}`;
    },
    cargosFiltrados(){
      const cargos = Array.isArray(this.usuario.cargos) ? this.usuario.cargos : [];
      if (!this.buscarCargo) return cargos;
      const q = this.buscarCargo.toLowerCase();
      return cargos.filter(c => [
        this.nombreCargo(c),
        this.nombreSedeCargo(c),
      ].some(v => String(v || '').toLowerCase().includes(q)));
    },
    datosTalento(){
      return this.talento && this.talento.datos ? this.talento.datos : null;
    },
    ultimoContrato(){
      return this.datosTalento && this.datosTalento.ultimoContrato ? this.datosTalento.ultimoContrato : {};
    },
    nombreCompletoTalento(){
      const d = this.datosTalento || {};
      return `${d.primerNombre || ''} ${d.otrosNombres || ''} ${d.apellidoPaterno || ''} ${d.apellidoMaterno || ''}`.trim() || 'S/D';
    },
    ciTalento(){
      const d = this.datosTalento || {};
      return `${d.nroCi || ''}${d.complementoCi ? '-' + d.complementoCi : ''} ${d.expedidoCi || ''}`.trim() || 'S/D';
    },
    lugarNacimientoTalento(){
      const d = this.datosTalento || {};
      return [d.ciudadNacimiento, d.departamentoNacimiento, d.paisNacimiento].filter(Boolean).join(', ') || 'S/D';
    },
  },
  methods:{
    parseUs(){
      if( this.usuario.seg_apellido == null ) this.usuario.seg_apellido = '';
      return `${this.usuario.nombres || ''} ${this.usuario.pri_apellido || ''} ${this.usuario.seg_apellido || ''}`.trim() || 'Usuario';
    },
    nombreCargo(cargo){
      return cargo && cargo.cargo && cargo.cargo.nombre ? cargo.cargo.nombre : 'Cargo S/D';
    },
    nombreSedeCargo(cargo){
      return cargo && cargo.sede && cargo.sede.nombre ? cargo.sede.nombre : 'Sede S/D';
    },
    fechaCorta(fecha){
      if (!fecha) return '';
      const fs = String(fecha).split(/[T ]/)[0].split('-');
      if (fs.length !== 3) return fecha;
      return `${fs[2]}/${fs[1]}/${fs[0]}`;
    },
    getDatos(){
      var sql = gql`query{getUsuario(id:${this.usuario.id}){ id,datos_personales{id,num_doc,nombres,pri_apellido,seg_apellido},cargos{cargo{nombre},sede{nombre}}}}`

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        this.usuario = data.data.getUsuario.datos_personales;
        this.usuario.cargos = data.data.getUsuario.cargos;
        this.buscarTalentoHumano();
      }).catch((error) => {
        window.console.error(window.stringifyObject(error));
        this.$notify( parseJsonError( error,'getUsuario' ) )
        this.buscarTalentoHumano();
      })
    },
    async buscarTalentoHumano(){
      const ci = this.usuario && this.usuario.num_doc ? this.usuario.num_doc : '';
      if (!ci) {
        this.talentoError = 'El usuario no tiene CI registrado para consultar Talento Humano.';
        return;
      }

      const url = process.env.VUE_APP_RRHH + '/empleados/validar?nro_ci=' + ci;
      const tokenStatic = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaXN0ZW1hIjoic2lzdGVtYV9wb3J0YWwiLCJpYXQiOjE3Mjg1MDgxNTAsImV4cCI6MzE3MjcyOTUwNTUwfQ.mo9Y8O-B4-AIoMt2rHKqVUZrDy_Z5oBZAn1VrrMLFzg';
      const h = { method: 'GET', headers: { 'Authorization': `Bearer ${tokenStatic}`, 'Content-Type': 'application/json' } };

      this.existeInTalento = false;
      this.buscandoTalento = true;
      this.talentoError = '';
      this.talento = null;

      try {
        const res = await fetch(url, h).then(r => r.json());
        this.talento = res;
        this.existeInTalento = !!(res && res.codigoEstado === 200 && res.datos);
        if (!this.existeInTalento) this.talentoError = res && res.mensaje ? res.mensaje : '';
      } catch (e) {
        window.console.error(e);
        this.talentoError = 'No se pudo consultar la informacion de Talento Humano.';
      } finally {
        this.buscandoTalento = false;
      }
    },
  },
  mounted(){
    this.usuario = { ...this.$store.state.DATA_USER, cargos: [] };
    this.getDatos();
  }
}
</script>

<style scoped>
.perfil-page {
  background: #f6f9fd;
  min-height: calc(100vh - 64px);
}

.perfil-hero {
  background:
    linear-gradient(135deg, rgba(255,255,255,.94) 0%, rgba(239,248,255,.96) 48%, rgba(196,232,255,.92) 100%),
    linear-gradient(90deg, #eaf6ff 0%, #ffffff 100%);
  border: 1px solid #d9edf9;
  border-radius: 8px;
}

.perfil-hero-content {
  display: flex;
  align-items: center;
  gap: 18px;
}

.perfil-avatar {
  flex: 0 0 auto;
  border: 1px solid #c7e7f8;
  box-shadow: 0 10px 26px rgba(21, 101, 192, .16);
}

.perfil-title-block {
  min-width: 0;
}

.perfil-title {
  color: #17456f;
}

.perfil-subtitle {
  color: #557085;
}

.perfil-logo {
  max-height: 64px;
  max-width: 180px;
  object-fit: contain;
  opacity: .78;
}

.perfil-card {
  border-radius: 8px;
  background: #fff;
}

.perfil-card-title {
  gap: 12px;
}

.perfil-search {
  max-width: 320px;
}

.perfil-field {
  border: 1px solid #e7ebf0;
  border-radius: 8px;
  padding: 10px 12px;
  min-height: 70px;
  background: #fbfcfe;
}

.perfil-field span {
  display: block;
  font-size: 12px;
  color: #6b7785;
  margin-bottom: 4px;
}

.perfil-field strong {
  display: block;
  color: #263238;
  line-height: 1.25;
  word-break: break-word;
}

.perfil-contract {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  border: 1px solid #d5ecfb;
  background: #f5fbff;
  border-radius: 8px;
  padding: 12px;
}

.perfil-contract-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  flex: 0 0 auto;
}

.perfil-table {
  border-radius: 0 0 8px 8px;
}

@media (max-width: 600px) {
  .perfil-hero-content {
    align-items: flex-start;
  }

  .perfil-logo {
    display: none;
  }

  .perfil-search {
    max-width: none;
    width: 100%;
  }
}
</style>
